import styles from './index.module.scss'
import { Dropdown, Input, Space, Select, message } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useState, useContext, useEffect } from 'react'
import SelectBtnGroups from '@view/page_v3/components/SelectBtnGroups';
import { ProjectContext } from '../../../hooks/ProjectContext'
import Iconfont from '@utils/Iconfont';
import { AppContext } from '@utils/AppContext';
import { IMAGE_TYPE } from '@utils/CONST'
import API from '@api/api.js';


const ProListpageTop = (props) => {
    const {
        proOrder, setProOrder,
        proSortField, setProSortField,
        proFunction, setProFunction,
        projectName, setProjectName
    } = useContext(ProjectContext)
    const { proSidebarValue, globalOrgInfo } = useContext(AppContext);
    const [memberList, setMemberList] = useState([]);


    const getListOrgMember = () => {
        API.getListOrgMember({}).then((res) => {
            if (res.code !== 0) return message.error(res.msg);
            const list = res.data.filter(item => item.role != 'admin').map(item => ({
                value: item.userId,
                label: item.deleted ? item.orgNickname + '（已移除）' : item.orgNickname,
            }));
            setMemberList(list);
        });
    }
    const memberChange = value => {
        props.setMember(value || 'team')
    }

    useEffect(() => {
        getListOrgMember()
    }, [])

    const sortChange = (value) => {
        if (value == 'updatedTimeAsc') {
            setProSortField('updatedTime')
            setProOrder('asc')
        } else if (value == 'updatedTimeDesc') {
            setProSortField('updatedTime')
            setProOrder('desc')
        } else if (value == 'projectNameAsc') {
            setProSortField('projectName')
            setProOrder('asc')
        } else if (value == 'projectNameDesc') {
            setProSortField('projectName')
            setProOrder('desc')
        }
    }

    const typeOptions = {
        'model': [
            { value: '', label: <span>全部项目类型</span> },
            { value: 'clothes', label: <span>AI试衣图</span> },
            { value: 'simTryon', label: <span>同版型试衣</span> },
            { value: 'model', label: <span>换模特/背景图</span> },
            { value: 'shoesTryon', label: <span>鞋子上脚图</span> },
            { value: 'glassesTryon', label: <span>眼镜试戴图</span> },
            { value: 'poseFantasy', label: <span>姿势裂变</span> },
            { value: 'clothRecolor', label: <span>服饰换色</span> }

        ],
        'commodity': [
            { value: '', label: <span>全部项目类型</span> },
            { value: 'commodity', label: <span>AI商品图</span> },
            { value: 'commodityRecolor', label: <span>商品换色图</span> }
        ],
        'aiEdit': [
            { value: '', label: <span>全部项目类型</span> },
            { value: 'aiImageExtraction', label: <span>智能抠图</span> },
            { value: 'imageResize', label: <span>高清改尺寸</span> },
            { value: 'aibeauty', label: <span>智能补光</span> },
            { value: 'aiSmartBeauty', label: <span>智能美化</span> },
            { value: 'removeInpaint', label: <span>魔法擦除</span> },
            { value: 'handFix', label: <span>手部修复</span> },
        ]
    }


    const proFunctionChange = (value) => {
        setProFunction(value)
    }

    return (
        <div className={styles.ProListpageTop}>
            <div>
                <Select
                    onChange={sortChange}
                    style={{ width: 160, marginRight: '8px' }}
                    defaultValue={'updatedTimeDesc'}
                    options={[
                        { value: 'updatedTimeDesc', label: <span>最新修改</span> },
                        { value: 'updatedTimeAsc', label: <span>最早修改</span> },
                        { value: 'projectNameAsc', label: <span>名称正序 A-Z</span> },
                        { value: 'projectNameDesc', label: <span>名称倒序 Z-A</span> },
                    ]}
                />
                {
                    proSidebarValue != 'modelVideo' && <Select
                        onChange={proFunctionChange}
                        style={{ width: 160, marginRight: '8px' }}
                        value={proFunction}
                        options={typeOptions[proSidebarValue]}
                    />
                }
                {
                    (globalOrgInfo?.current?.role == 'admin' && props.tabKey == '2') && <Select
                        style={{ width: 200, marginRight: '8px' }}
                        allowClear
                        member={props.member}
                        onChange={memberChange}
                        placeholder="请选择成员"
                        options={memberList}
                    />
                }

                <Input
                    allowClear
                    value={projectName}
                    className={styles.focused}
                    placeholder="请搜索项目名称"
                    suffix={<Iconfont type="icon-SearchOutlined" style={{ fontSize: 16, color: '#5b6673' }} />}
                    onChange={(e) => setProjectName(e.target.value)}
                />
            </div>
            <SelectBtnGroups
                getIsSelected={props.getIsSelected}
                setSelectedList={props.setSelectedList}
                selectedList={props.selectedList}
                isSelectedAll={props.isSelectedAll}
                downLoading={props.downLoading}
                selectAll={props.selectAll}
                deleteClick={props.deleteClick}
                downClick={props.downClick}
            />
        </div>
    )
}

export default ProListpageTop
